import React from 'react';
import { Authenticator } from "@aws-amplify/ui-react";
import { Amplify } from "aws-amplify";
import "@aws-amplify/ui-react/styles.css";
import outputs from './amplifyconfiguration.json';
import './App.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import {ThemeProvider as AmplifyThemeProvider} from '@aws-amplify/ui-react';

import MapComponent from "./features/Map/MapComponent.js";
import MenuBar from './features/Menubar/MenuBar.js';
import { MapProvider } from "./contexts/MapContext";
import { LIDProvider } from "./contexts/LIDContext";
import CompareResults from './features/Not-Currently-Used/ComparePlans/CompareResults.jsx';
import {components, moddedTheme} from './ui-components/AuthUI';

Amplify.configure(outputs);


function App() {
  return (

    <AmplifyThemeProvider theme={moddedTheme} colorMode="dark">
      <Authenticator components={components}>
        <div className="app-container">
          <MapProvider>
            <Router>
                <Routes>
                  <Route path="/" element={(
                      <>
                        <LIDProvider>
                          <MenuBar />
                          <MapComponent />
                        </LIDProvider>
                      </>
                  )} />
                  <Route path="/compare-results" element={<CompareResults />} />
                </Routes>
            </Router>
          </MapProvider>
        </div>
      </Authenticator>
    </AmplifyThemeProvider>
  );

}

export default App;